import React from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { Application } from "../../..";
import { IAppState, ErrorDisplay, LoadingDisplay, ResponseError } from "../../../../Common";
import AppSelectorList from "./AppSelectorList";

type Props = {
  defaultSelectedAppId: string;
  onSelectedAppChange: (selectedApp: string) => void;
};

type StateProps = {
  isLoading: boolean;
  isLoaded: boolean;
  isErrored: boolean;
  errorCode?: number;
  errorDescription?: string;
  apps: Application[];
};
type State = {
  selectedAppId: string;
  defaultAppId: string;
};

function mapStateToProps(state: IAppState): StateProps {
  return {
    isLoading: state.app.appsLoadingState.isLoading,
    isLoaded: state.app.appsLoadingState.isLoaded,
    isErrored: state.app.appsLoadingState.errored,
    errorCode: state.app.appsLoadingError.errorCode,
    errorDescription: state.app.appsLoadingError.errorDescription,
    apps: state.app.applications
  };
}

class AppSelectorListContainer extends React.Component<Props & StateProps, State> {
  constructor(props: Props & StateProps) {
    super(props);

    this.state = {
      selectedAppId: this.props.defaultSelectedAppId,
      defaultAppId: this.props.defaultSelectedAppId
    };

    this.onSelectedAppChange = this.onSelectedAppChange.bind(this);
  }

  componentDidUpdate(prevProps: Props & StateProps, prevState: State) {
    if (this.props.defaultSelectedAppId !== this.state.defaultAppId) {
      // default has been changed, reset the selected
      this.setState((oldState: State) => {
        return {
          ...oldState,
          selectedAppId: this.props.defaultSelectedAppId,
          defaultAppId: this.props.defaultSelectedAppId
        };
      });
    }
    // check if selected app has changed
    else if (this.state.selectedAppId !== prevState.selectedAppId) {
      // call the callback
      this.props.onSelectedAppChange(this.state.selectedAppId);
    }
  }

  onSelectedAppChange(selectedAppId: string) {
    this.setState((prevState: State) => {
      return {
        ...prevState,
        selectedAppId
      };
    });
  }

  render() {
    if (this.props.isErrored) {
      return (
        <ErrorDisplay
          errorCode={this.props.errorCode}
          errorDescription={this.props.errorDescription}
          errorResult="Could not display App Selector List"
        />
      );
    }
    if (this.props.isLoading) {
      return <LoadingDisplay />;
    }
    if (this.props.isLoaded) {
      return (
        <AppSelectorList
          selectedAppId={this.state.selectedAppId}
          apps={this.props.apps}
          onSelectedAppChange={this.onSelectedAppChange}
        />
      );
    }
    return <></>;
  }
}

export default connect(mapStateToProps)(AppSelectorListContainer);
